// Maps backend WTSException.code values to user-facing messages.
//
// Source of truth: WTS-Backend-Admin-API — every code here was verified to
// exist in app/features/*/business.py or app/core/exceptions.py.
// Do NOT add codes that do not exist in the backend.
//
// The client interceptor (lib/api/client.ts) falls back to the raw backend
// message when a code is absent from this map, so this map only needs entries
// where the frontend provides clearer context than the backend message alone.

export const ERROR_MESSAGES: Record<string, string> = {
  // ── Auth ──────────────────────────────────────────────────────────────────
  INVALID_CREDENTIALS: 'Invalid email or password.',
  ACCOUNT_SUSPENDED: 'Your account has been suspended. Contact your administrator.',
  UNAUTHORIZED: 'You are not authorised to perform this action.',
  FORBIDDEN: 'Access denied. You do not have permission for this.',

  // ── Session ───────────────────────────────────────────────────────────────
  INVALID_REFRESH_TOKEN: 'Your session has expired. Please sign in again.',
  REFRESH_TOKEN_EXPIRED: 'Your session has expired. Please sign in again.',
  SESSION_REVOKED: 'Your session has been revoked. Please sign in again.',
  SESSION_NOT_FOUND: 'Session not found. Please sign in again.',

  // ── MFA ───────────────────────────────────────────────────────────────────
  MFA_REQUIRED: 'Multi-factor authentication is required for your role.',
  MFA_CODE_INVALID: 'Invalid verification code. Please try again.',
  INVALID_MFA_TOKEN: 'MFA session expired or invalid. Please sign in again.',
  MFA_NOT_REQUIRED_FOR_ROLE: 'MFA setup is only available for Super Admin and Finance Admin.',
  MFA_ALREADY_ENABLED: 'MFA is already enabled on your account.',
  MFA_NOT_ENABLED: 'MFA is not enabled on your account.',
  MFA_SETUP_NOT_INITIATED: 'MFA setup has not been started. Please initiate setup first.',

  // ── General ───────────────────────────────────────────────────────────────
  NOT_FOUND: 'The requested resource was not found.',
  INVALID_INPUT: 'Please check your input and try again.',
  ALREADY_EXISTS: 'This resource already exists.',
  ALREADY_ACTIVE: 'This item is already active.',
  ALREADY_INACTIVE: 'This item is already inactive.',
  INVALID_OPERATION: 'This operation is not permitted in the current state.',
  INVALID_ROLE: 'Invalid role specified.',
  INTERNAL_ERROR: 'An unexpected error occurred. Please try again later.',

  // ── Invite / password reset ───────────────────────────────────────────────
  ACCOUNT_PENDING: 'Your account is pending activation. Please check your invitation email.',
  INVITE_ALREADY_ACCEPTED: 'This invitation has already been accepted. Please sign in instead.',
  INVALID_INVITE_TOKEN: 'This invite link is invalid or has expired. Please contact your administrator.',
  INVALID_RESET_TOKEN: 'This reset link is invalid or has expired. Please request a new one.',

  // ── Client-side only ──────────────────────────────────────────────────────
  // Synthesized in lib/api/client.ts when no server response is received.
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
};

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.';
